//
// Handles clipboard copying for the task view message template card.
//
window.addEventListener('DOMContentLoaded', () => {

	const container = document.querySelector('[data-copy-template]');
	if (!container) {
		return;
	}

	const subjectField = container.querySelector('[data-copy-template-subject-field]');
	const bodyField = container.querySelector('[data-copy-template-body-field]');
	const copyButtons = container.querySelectorAll('[data-copy-template-button]');
	const feedback = container.querySelector('[data-copy-template-feedback]');
	let feedbackTimer = null;

	//
	// Shows a short feedback message confirming the copy succeeded.
	//
	const showFeedback = () => {

		if (!feedback) {
			return;
		}
		feedback.classList.remove('d-none');
		if (feedbackTimer) {
			clearTimeout(feedbackTimer);
		}
		feedbackTimer = setTimeout(() => {
			feedback.classList.add('d-none');
		}, 2000);
	};

	//
	// Copies the provided text using the async clipboard API with a textarea fallback.
	//
	const copyText = async (text) => {

		if (!text) {
			return;
		}

		if (navigator.clipboard && window.isSecureContext) {
			try {
				await navigator.clipboard.writeText(text);
				showFeedback();
				return;
			} catch (error) {
				// Fall through to the legacy execCommand path below.
			}
		}

		const temp = document.createElement('textarea');
		temp.value = text;
		temp.setAttribute('readonly', '');
		temp.style.position = 'absolute';
		temp.style.left = '-9999px';
		document.body.appendChild(temp);
		temp.select();
		try {
			document.execCommand('copy');
			showFeedback();
		} finally {
			document.body.removeChild(temp);
		}
	};

	copyButtons.forEach(button => {
		button.addEventListener('click', () => {
			const target = button.getAttribute('data-copy-template-button');
			if (target === 'subject') {
				copyText(subjectField.value);
			} else if (target === 'body') {
				copyText(bodyField.value);
			}
		});
	});
});
